<script>
import DictText from "@/components/dict/DictText.vue";
import TableList from "@/components/table-list/TableList.vue";
import {request, requestByTip} from "@/config/request";

export default {
  name: "ImportCodeList" ,
  components: {TableList, DictText},
  props: {
    height: {
      type: Number,
      default: 0
    },
    searchParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tableData: [],
      selection: [],
      requestParams: {}
    }
  },
  methods: {
    async handleLoadList(params, setTotal) {
      try {
        let res = await request(this.$api.mac.list, {...params, type: "import"});
        this.tableData = res.macs;
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    },

    handleSearch() {
      this.$refs.list.handleSearch();
    },

    reset() {
      this.$refs.list.reset();
    },

    // 解锁
    async handleChangeStatus(row) {
      try {
        const params = {...row};
        delete params.createTime;
        delete params.updateTime;
        delete params.expireTime;
        params.status = row.status === "open" ? "close" : "open";
        const message = row.status === "open" ? this.$t('是否确认禁用？') : this.$t('是否确认启用？');
        await requestByTip(this.$api.mac.update, params, {}, {message});
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    handleSort(e) {
      const sortMap = {
        "ascending": "asc",
        "descending": "desc",
      }
      const fieldMap = {
        status: "orderStatus",
        createTime: "orderCreateTime",
      }
      this.requestParams[fieldMap[e.prop]] = sortMap[e.order];
      this.$refs.list.handleRequest();
    },
  }
}
</script>

<template>
  <table-list
      :height="height"
      ref="list"
      @query="handleLoadList"
      :search-params="searchParams"
      :request-params="requestParams"
      :data="tableData"
      :indent="16"
      @sort-change="handleSort"
      @selection-change="selection = $event">

    <el-table-column type="selection" width="50"/>
    <el-table-column type="index" label="序号" width="50" fixed />
    <el-table-column prop="createTime" :label="$t('导入日期')" fixed sortable="custom">
      <template v-slot="{row}">
        {{row.createTime | formatDate}}
      </template>
    </el-table-column>
    <el-table-column prop="macCode" :label="$t('MAC码')" fixed />
    <el-table-column prop="macCode" :label="$t('是否激活')">
      <template v-slot="{row}">
        <dict-text dict-flag="MAC_ACTIVE_STATUS" :status="row.isActive" />
      </template>
    </el-table-column>
    <el-table-column prop="status" :label="$t('状态')" sortable="custom">
      <template v-slot="{row}">
        <dict-text dict-flag="MAC_CODE_STATUS" :status="row.status" />
      </template>
    </el-table-column>
    <el-table-column fixed="right" :label="$t('操作')" width="100">
      <template v-slot="{row}">
        <div class="fb-link-flex">
          <el-link
              :type="row.status === 'open' ? 'danger' : 'primary' "
              :underline="false"
              @click="handleChangeStatus(row)">{{ row.status === 'open' ? $t('禁用') : $t('启用') }}</el-link>
        </div>
      </template>
    </el-table-column>
  </table-list>
</template>

<style scoped>

</style>
